import React from 'react'
import { NavLink } from 'react-router-dom'
import { Menu } from 'antd'
import { isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { APP_ROUTES, PERMISSIONS } from '../../../common/constants'

import { useUserHasPermissions } from '../../../account/hooks'
import { useSopsQuery } from '../../hooks'
import { StyledSubMenu } from '../styled'

const SopsNavLink = ({ imitateDisabled }) => {
  const { data } = useSopsQuery()
  const hasPermission = useUserHasPermissions([PERMISSIONS.SOP.LIST])

  const title = (
    <NavLink to={APP_ROUTES.MISC.children.SOPS.fullPath}>
      {APP_ROUTES.MISC.children.SOPS.label}
    </NavLink>
  )

  if (isEmpty(data) || !hasPermission) {
    return title
  }

  return (
    <StyledSubMenu title={title} imitateDisabled={imitateDisabled}>
      {map(data, ({ name, link }) => (
        <Menu.Item key={link}>
          <a href={link} rel="noreferrer" target="_blank">
            {name}
          </a>
        </Menu.Item>
      ))}
    </StyledSubMenu>
  )
}

SopsNavLink.propTypes = {
  imitateDisabled: PropTypes.bool,
}

SopsNavLink.defaultProps = {
  imitateDisabled: false,
}

export default SopsNavLink
